import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appShowPasswordToggle]'
})
export class ShowPasswordToggleDirective {

  private _shown = false;

  constructor(private el: ElementRef) {
    const parent = this.el.nativeElement.parentNode;
    const span = document.createElement('span');
    span.innerHTML = 'TOON';
    span.classList.add('show-password-toggle', 'unselectable');
    span.addEventListener('click', () => {
      this.toggle(span);
    });
    parent.appendChild(span);
  }

  toggle(span: HTMLElement) {
    this._shown = !this._shown;
    if (this._shown) {
      this.el.nativeElement.setAttribute('type', 'text');
      span.innerText = 'VERBERG';
      span.classList.toggle('active');
    } else {
      span.innerText = 'TOON';
      this.el.nativeElement.setAttribute('type', 'password');
      span.classList.toggle('active');
    }
  }
}
